import script from "./AdminPriceListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPriceListView.vue?vue&type=script&setup=true&lang=js"

import "./AdminPriceListView.vue?vue&type=style&index=0&id=45db48cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45db48cb"]])

export default __exports__